import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewEncapsulation,
  booleanAttribute,
} from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: `textarea[vinnova-textarea]`,
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TextareaComponent implements OnInit {
  mousedown: boolean;

  @Input() set size(value: 'small' | 'medium' | 'large') {
    this.elementRef.nativeElement.classList.add(value);
  }

  @Input({ transform: booleanAttribute }) set error(value: boolean) {
    this.elementRef.nativeElement.classList.toggle('invalid', value);
  }

  @Input({ transform: booleanAttribute }) set required(value: boolean) {
    if (value) {
      this.elementRef.nativeElement.setAttribute('aria-required', 'true');
    } else {
      this.elementRef.nativeElement.removeAttribute('aria-required');
    }
  }

  @Input() set placeholder(value: string) {
    this.elementRef.nativeElement.placeholder = value ?? '';
  }

  @Output() keydownOutput = new EventEmitter();

  constructor(
    public elementRef: ElementRef,
    private zone: NgZone,
  ) {}

  ngOnInit() {
    this.elementRef.nativeElement.classList.add(
      'form-control',
      'vinnova-textarea',
    );
  }

  @HostListener('mousedown')
  onMousedown() {
    if (this.elementRef.nativeElement === document.activeElement) {
      this.elementRef.nativeElement.classList.remove('focus-visible');
    }
    this.mousedown = true;
  }

  @HostListener('focus')
  onFocus() {
    this.elementRef.nativeElement.classList.add('focus');
    if (!this.mousedown) {
      this.elementRef.nativeElement.classList.add('focus-visible');
    }
    this.mousedown = false;
  }

  @HostListener('blur')
  onBlur() {
    this.elementRef.nativeElement.classList.remove('focus-visible');
  }

  @HostListener('keydown', ['$event'])
  onKeyEnter(event) {
    this.elementRef.nativeElement.classList.remove('focus-visible');
    if (event.key !== 'Tab') {
      this.keydownOutput.emit();
    }
  }
}
